import { useTranslation } from "react-i18next";

import { Grid } from "@mui/material";
import { FormikProps } from "formik";

import { ContentCard } from "../../../../../../content-card/ContentCard";
import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { nameof } from "../../../../../../utils/nameof";
import { ProceedingParticipantSearchResult } from "../../../../../api/ClientFileApi";
import { AssetPersonalDataFormValues, createEmptyAccount } from "../../AssetPersonalData.types";
import { AccountFields } from "../account-fields/AccountFields";
import { FieldWithInfo } from "../field-with-info/FieldWithInfo";
import { BankParticipantSelect } from "./BankParticipantSelect";

interface Props {
  formik: FormikProps<AssetPersonalDataFormValues>;
}

export function SalaryAccountBlock({ formik }: Props) {
  const { t } = useTranslation();
  const { accounts, hasOwnAccount } = formik.values;

  const onOwnAccountChange = (value: boolean | null) => {
    if (value === true && accounts.length === 0) {
      void formik.setFieldValue(nameof<AssetPersonalDataFormValues>("accounts"), [createEmptyAccount()]);
    }
  };

  const onBankChange = (participant: ProceedingParticipantSearchResult | null) => {
    if (!participant) {
      return;
    }
    const next = accounts.map((a) => ({
      ...a,
      bankName: participant.name,
      bankStreet: participant.street,
      bankHouseNumber: participant.houseNumber,
      bankZipCode: participant.zipCode,
      bankCity: participant.city,
      bankCountry: participant.country,
    }));
    void formik.setFieldValue(nameof<AssetPersonalDataFormValues>("accounts"), next);
  };

  return (
    <ContentCard title={t("clients.client.debtSettlement.assetInventory.section1.salaryAccountTitle")}>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid size={6}>
          <FieldWithInfo
            fieldLabel={t("clients.client.debtSettlement.assetInventory.section1.hasOwnAccountQuestion")}
            info={t("clients.client.debtSettlement.assetInventory.section1.accountQuestionInfo")}
          >
            <FormikYesNoAutocomplete
              formik={formik}
              fieldName="hasOwnAccount"
              onValueChange={onOwnAccountChange}
              label={t("clients.client.debtSettlement.assetInventory.section1.hasOwnAccountQuestion")}
              required
            />
          </FieldWithInfo>
        </Grid>
        {hasOwnAccount && (
          <Grid size={6}>
            <BankParticipantSelect
              formik={formik}
              fieldName="bankId"
              label={t("clients.client.debtSettlement.assetInventory.section1.bankConnection")}
              onParticipantChange={onBankChange}
            />
          </Grid>
        )}
      </Grid>

      {hasOwnAccount === true && <AccountFields formik={formik} index={0} />}
    </ContentCard>
  );
}
